<div class="modal-header">
  <h4 class="modal-title">
    @if (camera) {
      Editar cámara {{ camera.cameraId }}
    }

    @if (!camera) {
      Nueva cámara
    }
  </h4>
  <button 
    type="button" 
    class="btn-close" 
    aria-label="Close" 
    (click)="activeModal.dismiss('Cross click')">
  </button>
</div>

<div class="modal-body">
  @if (!loading) {
    <form
      id="formCamera"
      [formGroup]="formCamera"
      (ngSubmit)="onSubmit()">
      <div class="container-fluid">
        <div class="row">

          @for (key of utilService.objectKeys(dataForm); track key) {

            @if (
              dataForm[key].type == 'text' ||
              dataForm[key].type == 'password'
            ) {
              <div class="col-12 form-group mb-4">
                <label [htmlFor]="key" class="form-label">
                  {{ dataForm[key].label }}
                </label>
                <input
                  [type]="dataForm[key].type"
                  class="form-control"
                  formControlName="{{ key }}"
                  [placeholder]="dataForm[key].placeholder ?? dataForm[key].label"
                  [ngClass]="{
                    'is-invalid': submitted && f[key].errors
                  }">
                @if (submitted && f[key].errors && dataForm[key].required) {
                  <div class="invalid-feedback">
                    @if (f[key].errors['required']) {
                      {{ dataForm[key].requiredMessage }}
                    }
                  </div>
                }
              </div>
            }

            @if (
              dataForm[key].type == "number"
            ) {

              <div class="col-12">
                <div class="row">

                  <div class="col-12 mb-2">
                    {{ dataForm[key].label }}
                  </div>

                  <p-inputNumber
                    [formControlName]="key"
                    [showButtons]="true"
                    buttonLayout="horizontal"
                    spinnerMode="horizontal"
                    styleClass="w-100 mb-4"
                    min="0"
                    decrementButtonClass="p-button-secondary"
                    incrementButtonClass="p-button-secondary"
                    incrementButtonIcon="pi pi-plus"
                    decrementButtonIcon="pi pi-minus" />

                </div>
              </div>

            }

            @if (dataForm[key].type === 'select') {
              <div class="col-12 mb-4">
                <div class="mb-1">
                  {{ dataForm[key].label }}
                </div>
                <ng-select
                  [items]="dataForm[key].data!"
                  [bindLabel]="dataForm[key].labelSelect!"
                  [bindValue]="dataForm[key].idSelect!"
                  formControlName="{{ key }}"
                  [placeholder]="dataForm[key].placeholder ?? ''">
                </ng-select>
              </div>
            }

          }

        </div>
      </div>
    </form>
  }
</div>

<div class="modal-footer">
  <div class="col-12 my-3">
    <button
      (click)="activeModal.close()"
      type="button"
      class="btn btn-outline-danger w-100">
      Cancelar
    </button>
  </div>
  <div class="col-12">
    <button
      type="submit"
      form="formCamera"
      class="btn btn-primary w-100">
      {{ camera ? 'Actualizar' : 'Registrar' }}
    </button>
  </div>
</div>
